export enum CALENDAR_TIME_RANGE {
  today = 'today',
  day = 'day',
  week = 'week',
  month = 'month',
  list = 'list',
}
